<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Carteira Crédito/Câmbio/Consórcio</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Carteira Crédito/Câmbio/Consórcio</h3>
<div mat-dialog-content>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="(data.cliente == null || data.cliente == undefined)">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input 
                matInput 
                placeholder="Digite o nome ou conta de um cliente" 
                aria-label="Cliente"  
                [formControl]="cliente" 
                name="cliente" 
                required
                [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="(data.cliente != null && data.cliente != undefined)">
        <p>
            <b>{{data.cliente.nome}}</b>
        </p>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Empresa</mat-label>
            <mat-select 
                placeholder="Empresa"
                [(value)]="model.empresa_consorcio_id" 
                [formControl]="empresa_consorcio_id"
                name="empresa_consorcio_id"
                required             
            >
                <mat-option *ngFor="let item of listEmpresaConsorcio" [value]="item.id">{{item.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEmpresaConsorcio"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Tipo Operação</mat-label>
            <mat-select 
                placeholder="Tipo Operação"
                [(value)]="model.tipo_consorcio_id" 
                [formControl]="tipo_consorcio_id"
                name="tipo_consorcio_id"
                required
            >
                <mat-option *ngFor="let item of listTipoConsorcio" [value]="item.id">{{item.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEmpresaConsorcio"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" >
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>GRUPO</mat-label>
            <input 
                matInput 
                [formControl]="grupo" 
                name="grupo" 
                placeholder="GRUPO">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>COTA</mat-label>
            <input 
                matInput 
                [formControl]="cota" 
                name="cota" 
                placeholder="COTA">
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" >
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Prazo Grupo</mat-label>
            <input 
                matInput 
                type="number"
                [formControl]="prazo_grupo" 
                name="prazo_grupo" 
                placeholder="Prazo Grupo">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Prazo Cliente</mat-label>
            <input 
                matInput
                type="number"
                [formControl]="prazo_cliente" 
                name="prazo_cliente" 
                placeholder="Prazo Cliente">
        </mat-form-field>
    </div>

    <div mat-dialog-content>
        
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Taxa de Administração" 
                        [formControl]="taxa_administracao" 
                        required
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ suffix: ' %', thousands: '.', decimal: ',', align: 'center', prefix: '' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" >
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Data da Operação</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker_data_operacao" 
                [formControl]="data_operacao" 
                placeholder="Data da Operação"
                name="data_operacao">
            <mat-datepicker-toggle matSuffix [for]="picker_data_operacao"></mat-datepicker-toggle>
            <mat-datepicker #picker_data_operacao></mat-datepicker>
        </mat-form-field>
    </div>

    <div mat-dialog-content>
        
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">                
                    <input 
                        matInput 
                        placeholder="Valor Contratado" 
                        [formControl]="valor_contratado" 
                        required
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">                
                    <input 
                        matInput 
                        placeholder="Valor Lance em Potencial" 
                        [formControl]="valor_lance_potencial" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Valor Lance Efetivado" 
                        [formControl]="valor_lance_efetivado_contemplacao" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Valor Reembolso" 
                        [formControl]="valor_reembolso" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Valor Pago" 
                        [formControl]="valor_pago" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Saldo devedor" 
                        [formControl]="saldo_devedor" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between" >
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Data da Liberação do Crédito</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker_liberacao_credito" 
                [formControl]="liberacao_credito" 
                name="liberacao_credito" 
                placeholder="Data da Liberação do Crédito">
            <mat-datepicker-toggle matSuffix [for]="picker_liberacao_credito"></mat-datepicker-toggle>
            <mat-datepicker #picker_liberacao_credito></mat-datepicker>
        </mat-form-field>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Valor Crédito Liberado" 
                        [formControl]="valor_credito_liberado" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex.gt-sm="100%">
                <mat-form-field style="width: 100%">
                    <input 
                        matInput 
                        placeholder="Valor Crédito Autorizado" 
                        [formControl]="credito_autorizado" 
                        style="font-size: 30px;"
                        currencyMask 
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                        maxlength="255">
                </mat-form-field>
            </div>
        </div>
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>